







































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";

import { ref, computed } from "@vue/composition-api";
import { UseModal } from "@/components/root/modal";
import FileDetailsModalVue from "@/components/modals/FileDetailsModal.vue";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
  },
  setup(props) {
    const showLoader = ref(false);

    const tableRow = ref(null);
    const onFilesClicked = () => {
      EventBus.emit("show-files", {
        item: props.source,
        mode: "files",
        // @ts-ignore
        rowEl: tableRow.value.$el,
      });
    };

    const onCountClick = () => {
      EventBus.emit("show-events", {
        item: props.source,
        mode: "events",
        // @ts-ignore
        rowEl: tableRow.value.$el,
      });
    };

    const showMenu = (event: MouseEvent) =>
      EventBus.emit("showMenu", { item: props.source, event });

    return {
      showLoader,
      tableRow,
      onFilesClicked,
      onCountClick,
      showMenu,
    };
  },
});
